import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";

// components
import DataTableAndAnalytics from "../../components/DataTableAndAnalytics";
import PageHeader from "../../components/PageHeader";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

import { apiUrl, updateUserDocument } from "../../utils/variables";
import {
  setData,
  setFileName,
  setCsvName,
  setLastAutosaveDate,
} from "../../features/datatable/dataTableSlice";

const FileById = () => {
  const [isChangingFileName, setIsChangingFileName] = useState(false);
  const [newFileName, setNewFileName] = useState("");
  const { token, uid, fullName } = useSelector((state) => state.auth);
  const { documentId } = useParams();
  const { fileName, lastAutosaveDate } = useSelector(
    (state) => state.dataTable
  );
  const dispatch = useDispatch();

  const handleFileNameDisplay = () => {
    if (isChangingFileName) {
      return (
        <div>
          <TextField
            variant="standard"
            placeholder="Type here"
            value={newFileName}
            onChange={(e) => setNewFileName(e.target.value)}
            sx={{ marginRight: "10px" }}
          />
          <Button
            onClick={async () => {
              await updateUserDocument(token, uid, fullName, documentId, {
                "details.fileName": newFileName,
              });
              setIsChangingFileName(false);
              dispatch(setFileName(newFileName));
            }}
            sx={{
              color: "#777777",
              fontWeight: "700",
            }}
          >
            Save
          </Button>
        </div>
      );
    }

    return (
      <div>
        <h1
          style={{
            color: "#3F3F3F",
            flex: "0 0 275px",
            fontSize: "25px",
          }}
          onClick={() => {
            setIsChangingFileName(true);
          }}
        >
          {fileName}
        </h1>
      </div>
    );
  };

  useEffect(() => {
    const getDocumentData = async () => {
      const resp = await fetch(`${apiUrl}/documents/${documentId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const documentData = await resp.json();
      // console.log(documentData);
      const formattedDate = dayjs(documentData.lastEditDate).format(
        "MMM DD, YYYY; hh:mm A"
      );
      if (documentData.id === documentId) {
        dispatch(setFileName(documentData.fileName));
        dispatch(setData(documentData.gridData));
        dispatch(setCsvName(documentData.csvName));
        dispatch(setLastAutosaveDate(formattedDate));
        // console.log(documentData);
      }
    };
    getDocumentData();
  }, [dispatch, documentId, token]);

  return (
    <>
      <PageHeader>
        {handleFileNameDisplay()}
        <p
          style={{
            color: "#777777",
            fontWeight: "bolder",
          }}
        >
          Saved last {lastAutosaveDate}
        </p>
      </PageHeader>

      <DataTableAndAnalytics />
    </>
  );
};

export default FileById;
